import { NavigateFunction } from "react-router-dom";
import { TFunction } from "i18next";
import { Text } from "@pentabd/ui";

import { StatusBadge } from "@components";
import TableActions from "@components/TableActions";
import { VendorType } from "@type/procurements/vendor";

export const VendorsTableColumn = (
  t: TFunction<"translation", undefined>,
  navigate: NavigateFunction,
  openConfirmationModel: (itemName: string, id: string | number) => void,
) => {
  return [
    {
      id: 1,
      key: "vendorName",
      name: t("PROCUREMENT_VENDORS_TABLE.TABLE.COLUMN.NAME"),
      render: (vendorName: string) => {
        return <Text color="subtitle2">{vendorName}</Text>;
      },
    },
    {
      id: 2,
      key: "address",
      name: t("PROCUREMENT_VENDORS_TABLE.TABLE.COLUMN.ADDRESS"),
      render: (address: string) => {
        return <Text color="subtitle2">{address}</Text>;
      },
    },
    {
      id: 3,
      key: "isBlackList",
      name: t("PROCUREMENT_VENDORS_TABLE.TABLE.COLUMN.VENDOR_STATUS"),
      render: (isBlackList: boolean) => {
        return (
          <StatusBadge
            customStatus={!isBlackList ? "success" : "danger"}
            status={isBlackList ? "Blacklisted" : "WhiteListed"}
          />
        );
      },
    },
    {
      id: 4,
      key: "tradeLicenceNo",
      name: t("PROCUREMENT_VENDORS_TABLE.TABLE.COLUMN.TRADE_LICENSE_NO"),
      render: (tradeLicenceNo: string) => {
        return <Text color="subtitle2">{tradeLicenceNo}</Text>;
      },
    },
    {
      id: 5,
      key: "contactNo",
      name: t("PROCUREMENT_VENDORS_TABLE.TABLE.COLUMN.CONTACT_NUMBER"),
      render: (contactNo: string) => {
        return <Text color="subtitle2">{contactNo}</Text>;
      },
    },
    {
      id: 6,
      key: "vendorTypes",
      name: t("PROCUREMENT_VENDORS_TABLE.TABLE.COLUMN.VENDOR_TYPE"),
      render: (vendorTypes: string) => {
        return <Text color="subtitle2">{vendorTypes}</Text>;
      },
    },
    {
      id: 7,
      key: "approvalStatus",
      name: t("PROCUREMENT_VENDORS_TABLE.TABLE.COLUMN.APPROVAL_STATUS"),
      render: (approvalStatus: string) => (
        <StatusBadge status={approvalStatus} />
      ),
    },
    {
      id: 8,
      key: "id",
      name: "",
      render: (id: string | number, row: VendorType) => {
        return (
          <TableActions
            onClickEdit={() => {
              navigate(`${id}`);
            }}
            onClickDelete={() => openConfirmationModel(row?.vendorName, id)}
          />
        );
      },
    },
  ];
};
